<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange_"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad_">
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>
      <!-- <template slot="menuRight">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-search"
                   @click="searchChange_">搜索
        </el-button>
        <el-button type="default"
                   size="small"
                   icon="el-icon-delete"
                   @click="searchReset">清空
        </el-button>
      </template> -->
               <template slot="userFlag" slot-scope="scope">
                 <span>{{scope.row.userFlag>0?'使用中':'未使用'}}</span>
                </template>

               <template slot="requiredFlag" slot-scope="scope">
                 <span>{{scope.row.requiredFlag>0?'是':'否'}}</span>
                </template>

               <template slot="projectIdForm" slot-scope="scope">
        <el-select
          v-model="form.projectId"
          placeholder="项目名称"
          style="width: 100%"
          @change="(value)=>projectChange(value,1)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="typeForm" slot-scope="scope">
        <el-select
          v-model="form.type"
          placeholder="项目名称"
          style="width: 100%"
          @change="(value)=>typeChange(value)"
        >
          <el-option
            v-for="item in typeList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>

      
      <template slot="venueIdForm" slot-scope="scope">
        <el-select
          v-model="form.venueId"
          placeholder="场馆名称"
          style="width: 100%"
          @change="(value)=>venueNameChange(value,1)"
        >
          <el-option
            v-for="item in venueNameList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="areaIdForm" slot-scope="scope">
        <el-select
          v-model="form.areaId"
          placeholder="请选择区域名称"
          style="width: 100%"
          @change="(value)=>areaChange(value,1)"
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      
      <template slot="chargeTypeForm" slot-scope="scope">
        <el-select
          v-model="form.chargeType"
          placeholder="请选择区域名称"
          style="width: 100%"
          @change="(value)=>chargeTypeChange(value,1)"
        >
          <el-option
            v-for="item in chargeTypeList_"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>

      <template slot="feeForm" slot-scope="scope">
        <div>
          <el-input
            v-model="form.fee"
            style="width:calc(100% - 2rem)"
          ></el-input>{{form.chargeType==2?' %':' /元'}}
        </div>
      </template>
      <template slot="userFlagForm" slot-scope="scope">
          <el-radio-group v-model="form.userFlag">
            <el-radio :label="0">未使用</el-radio>
            <el-radio :label="1">使用中</el-radio>
          </el-radio-group>
      </template>
      <template slot="requiredFlagForm" slot-scope="scope">
          <el-radio-group v-model="form.requiredFlag">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
      </template>
      
      <template slot="nameSearch" slot-scope="scope">
        <div>
          <el-input
            v-model="query.name"
          placeholder="服务名称"
          ></el-input>
        </div>
      </template>
      <template slot="chargeTypeSearch" slot-scope="scope">
        <el-select
        clearable
          v-model="query.chargeType"
          placeholder="区域名称"
          style="width: 100%"
          @change="(value)=>chargeTypeChange_(value)"
        >
          <el-option
            v-for="item in chargeTypeList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="projectIdSearch" slot-scope="scope">
        <el-select
          v-model="query.projectId"
          placeholder="项目名称"
          style="width: 100%"
          @change="(value)=>projectChange(value)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="areaIdSearch" slot-scope="scope">
        <el-select
          clearable
          v-model="query.areaId"
          placeholder="区域名称"
          style="width: 100%"
          @change="(value)=>areaChange(value)"
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>


    </avue-crud>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update, getAreaList, getVenueNameList, getVenueTypeList, getVenueChargeTypeList} from "@/api/v4ward/stadium-management/config";

  import {getProjectList} from "@/api/crmedical/project/project";

  export default {
    data() {
      return {
        chargeTypeList_:[],
        venueNameList:[],
        projectList:[],
        areaList:[],
        form: {
          requiredFlag:1,
          userFlag:1
        },
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          // menu:false,
          // menuBtn:false,
          // emptyBtn:false,
          // searchBtn:false,
          // columnBtn:false,
          height: 'auto',
          calcHeight: 90,
          tip: false,
          // searchShow: false,
          // searchShowBtn:false,
          // searchMenuSpan: 6,
          border: true,
          index: true,
          indexLabel:"序号",
          editBtn: true,
          viewBtn: true,
          selection: true,
          dialogClickModal: false,
          // refreshBtn:false,

          column: [
              
            {
              label: "项目名称",
              prop: "projectName",
              search: false,
              viewDisplay:false,
              addDisplay:false,
              editDisplay:false,
            },
            {
              label: "项目名称",
              prop: "projectId",
              hide:true,
              searchslot:true,
              searchClearable: false,
              formslot:true,
              search: true,
              type: 'tree',
              span:12,
              labelWidth:110,
              props: {
                label: 'name',
                value: 'id',
              },
              rules: [{
                required: true,
                message: "请输入项目名称",
                trigger: "change"
              }]
            },
            {
              label: "区域名称",
              prop: "areaName",
              search: false,
              viewDisplay:false,
              addDisplay:false,
              editDisplay:false,
            },
            {
              label: "区域名称",
              prop: "areaId",
              span:12,
              labelWidth:110,
              search:true,
              hide:true,
              searchslot:true,
              formslot:true,
              rules: [{
                required: true,
                message: "请输入区域名称",
                trigger: "change"
              }]
            },
            {
              label: "场馆类型",
              prop: "type",
              span:12,
              labelWidth:110,
              formslot:true,
              search:false,
              type: 'select',
              dataType: 'number',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=venue_type',
              rules: [{
                required: true,
                message: "请输入场馆类型",
                trigger: "change"
              }]
            },
            {
              label: "场馆名称",
              prop: "venueId",
              hide:true,
              formslot:true,
              search:false,
              span:12,
              labelWidth:110,
              rules: [{
                required: true,
                message: "请输入场馆名称",
                trigger: "change"
              }]
            },
            {
              label: "场馆名称",
              prop: "venueName",
              hide: false,
              viewDisplay:false,
              addDisplay:false,
              editDisplay:false,
              labelWidth:110,
            },
            {
              label: "服务名称",
              search:true,
              searchslot:true,
              prop: "name",
              span:12,
              labelWidth:110,
              maxlength:30,
              rules: [{
                required: true,
                message: "服务名称",
                trigger: "change"
              }]
            },
            {
              label: "收费方式",
              prop: "chargeType",
              span:12,
              labelWidth:110,
              formslot:true,
              search:true,
              searchslot:true,
              type: 'select',
              dataType: 'number',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=venue_charge_type',
              rules: [{
                required: true,
                message: "请输入场馆类型",
                trigger: "change"
              }]
            },
            {
              label: "服务费",
              prop: "fee",
              span:12,
              labelWidth:110,
              formslot:true,
              maxlength:20,
              
            headerAlign: 'left',
              align:"right",
              // addDisplay:false,
              // editDisplay:false,
              rules: [{
                required: true,
                message: "请输入服务费",
                trigger: "blur"
              }
              ,{
                trigger: "blur",
                  pattern: /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/,
                  message: '请输入小数点前9位后2位小数的金额'
              }
              ]
            },
            {
              label: "",
              prop: "",
              hide:true,
              formslot:true,
              span:12,
              labelWidth:110,
            },
            {
              label: "状态",
              prop: "userFlag",
              formslot:true,
              slot:true,
              span:12,
              labelWidth:110,
              // addDisplay:false,
              // editDisplay:false,
            },
            {
              label: "是否必选配置",
              prop: "requiredFlag",
              formslot:true,
              slot:true,
              labelWidth:110,
              span:12,
              // addDisplay:false,
              // editDisplay:false,
            },
            {
              label: "服务说明",
              prop: "description",
              type:'textarea',
              maxlength:500,
              showWordLimit:true,
              labelWidth:110,
              span:24,
            },
	
          ]
        },
        data: []
      };
    },
    computed: {
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    mounted(){
      window.onresize=()=>{
        this.$refs.crud.doLayout();
      }
      console.log();
      this.$refs.crud.$refs.headerMenu.$children[6].$el.style.display='none'
    },
    activated(){
      window.onresize=()=>{
        this.$refs.crud.doLayout();
      }
      this.$refs.crud.doLayout();
    },
    created(){
      getVenueTypeList().then((res)=>{
        this.typeList = res.data;
      });
      getVenueChargeTypeList().then((res)=>{
        this.chargeTypeList = res.data;
      });
      getProjectList().then((res)=>{
        this.projectList = res.data;
      })
    },
    methods: {
      chargeTypeChange(value){
        this.form = Object.assign({},this.form,{
          chargeType:value
        });
      },
      chargeTypeChange_(value){
        this.query = Object.assign({},this.query,{
          chargeType:value
        });
      },
      projectChange(value,type){
        if(type){
          this.form.projectId = value;
          this.form.areaId = '';
          this.form.venueId = '';
          this.venueNameList = [];
        }else{
          this.query.projectId = value;
          this.query.areaId = '';
          this.query.venueId = '';
          this.venueNameList = [];
        }
        getAreaList({ projectId: value }).then(({ data })=>{
          console.log("getAreaList=====>",data);
          this.areaList = data;
        });

        this.$forceUpdate();
      },
      areaChange(value,type){
        if(type){
          this.form = Object.assign({},this.form,{
            areaId:value
          });
        }else{
          this.query = Object.assign({},this.query,{
            areaId:value
          });
        }
        this.triggerGetVenueList();
      },
      typeChange(value){
        this.form = Object.assign({},this.form,{
          type:value
        });
        this.triggerGetVenueList();
      },
      venueNameChange(value){
        this.form = Object.assign({},this.form,{
          venueId:value
        });
      },
      triggerGetVenueList(type){
        if(this.form.areaId&&this.form.projectId&&this.form.type){
          
          if(!type){
            this.$refs.crud.$refs.dialogForm.$refs.tableForm.form.venueId = '';
          }
          console.log('===================triggerGetVenueList===================');
          getVenueNameList({areaId:this.form.areaId,projectId:this.form.projectId,type:this.form.type}).then((res)=>{
            console.log(res);
            this.venueNameList = res.data;
          });
        }
      },
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      filterChageTypeList(){
        let arr = [];
        this.chargeTypeList.forEach((ele)=>{
          if(ele.dictValue!=='全部'){
            arr.push(ele);
          }
        });
        this.chargeTypeList_ = arr;
      },
      beforeOpen(done, type) {
        console.log(this.form);
        this.form.projectId = this.query.projectId;
        let type_venue = this.form.type;
        this.filterChageTypeList();
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
            this.form.type = type_venue;
            getAreaList({ projectId: this.form.projectId }).then(({ data })=>{
              console.log("getAreaList=====>",data);
              this.areaList = data;
            });
            this.triggerGetVenueList(1);
          });
        }else{
          getAreaList({ projectId: this.form.projectId }).then(({ data })=>{
            console.log("getAreaList=====>",data);
            this.areaList = data;
          });
          this.form = Object.assign({},this.form,{
            userFlag:1,
            requiredFlag:1
          })
        }
        done();
      },
      getAreaList(projectId){
        getAreaList({projectId:projectId}).then((res)=>{
          this.areaList = res.data;
          this.areaList_ = res.data;
        });
      },
      searchReset() {
        let projectId = this.query.projectId;
        this.query = {};
        this.query.projectId = projectId;
        // this.query.projectId = this.projectList[0].id;
        this.query.chargeType = this.chargeTypeList[0].dictKey;
        this.getAreaList(this.query.projectId);
        this.$refs.crud.$refs.headerSearch.searchForm.chargeType=this.chargeTypeList[0].dictKey;
        this.$refs.crud.$refs.headerSearch.searchForm.name='';
        this.onLoad();
      },
      searchChange_(params, done){
        this.query = Object.assign({},this.query,{});
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      searchChange(params, done) {
        // this.query = params;
        this.query = Object.assign({},this.query,params);
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad_(page){
        page = page || this.page;
        this.loading = true;
        if(this.query.projectId){
          console.log();
          this.onLoad();
          return;
        }else{
        getVenueChargeTypeList().then(({data})=>{
          this.chargeTypeList = data;
        this.$refs.crud.$refs.headerSearch.searchForm.chargeType=this.chargeTypeList[0].dictKey;
          getProjectList().then((res)=>{
            this.projectList = res.data;
            this.projectList_ = res.data;
            this.query.projectId = res.data[0].id;
            this.query.chargeType = this.chargeTypeList[0].dictKey;
            getAreaList({projectId:res.data[0].id}).then((res)=>{
              this.areaList = res.data;
              getList(
                Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
              ).then(({data}) => {
                this.page.total = data.total;
                this.data = data.records;
                this.loading = false;
                this.selectionClear();
              });
            })
          })
        })
        }
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          this.$refs.crud.doLayout();
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
::v-deep .avue-form__menu--center {
    text-align: right;
}
</style>
